module.exports = "<a href=\"$UpgradeLink\" id=\"upgrade-button\" class=\"upgrade-cta\">Upgrade</a>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/hubspot-upgrade-link.html
// module id = 441
// module chunks = 1